import PropTypes from 'prop-types';
import { trans } from '@spotahome/soyuz/client';

import './ListingEnergyCertificateModalInfoRow.scss';

const ListingEnergyCertificateModalInfoRow = ({
  title,
  certificateIsRequested,
  renderCertificateInfo
}) => (
  <li>
    <span className="listing-energy-certificate-modal-info-row">
      <span>{title}</span>
      {certificateIsRequested ? (
        <span>
          {trans('listing.energy-certificate.requested-to-landlord.short')}
        </span>
      ) : (
        renderCertificateInfo()
      )}
    </span>
  </li>
);

ListingEnergyCertificateModalInfoRow.propTypes = {
  title: PropTypes.string.isRequired,
  certificateIsRequested: PropTypes.bool.isRequired,
  renderCertificateInfo: PropTypes.func.isRequired
};

export default ListingEnergyCertificateModalInfoRow;
